import {
    getTopBikeListRequest,
    getTopCarListRequest,
    getTopCommercialListRequest,
    getTopDealerListRequest,
    getTopServiceListRequest,
    getTopCompanyListRequest,
    getTopRentListRequest,
    getTopPlacementListRequest,
    getTopPartsListRequest,
} from '../../../services/network/lists';

class CommonTopListService {
    async getTopRentList() {
        return await getTopRentListRequest();
    }

    async getTopCompanyList() {
        return await getTopCompanyListRequest();
    }

    async getTopPlacementList() {
        return await getTopPlacementListRequest();
    }

    async getTopServiceList() {
        return await getTopServiceListRequest();
    }

    async getTopDealerList() {
        return await getTopDealerListRequest();
    }

    async getTopCarList() {
        return await getTopCarListRequest();
    }

    async getTopBikeList() {
        return await getTopBikeListRequest();
    }

    async getTopCommercialList() {
        return await getTopCommercialListRequest();
    }

    async getTopPartsList() {
        return await getTopPartsListRequest();
    }
}

export const TopListService = new CommonTopListService();
